import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import path from 'ramda/es/path';
import { parse } from 'query-string';
import * as ReactDOM from 'react-dom';
import { iframeResizer as syncIframeSize } from 'iframe-resizer';
import uniqueId from 'lodash.uniqueid';
// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import iframeResizerContentWindow from '!file-loader!iframe-resizer/js/iframeResizer.contentWindow';
// eslint-disable-next-line import/extensions,import/no-unresolved,import/no-webpack-loader-syntax
import gtmEelevatorScript from '!file-loader!./gtmElevator';
import { IFrame } from './iframeContent.styles';
import { cachedRequest } from '../../utils/cachedRequest';
import { SectionViewportContext } from '../contentManager/pageSection/pageSection.component';
import passthroughParams from '../../utils/passthroughParams';

const fetchCss = async src => {
  const { data } = await cachedRequest(src);
  return data;
};

const iframeHtml = type => {
  switch (type) {
    case 'doubleMyDonation':
      return 'ddIframe';
    default:
      return 'iframe';
  }
};

export class IframeContent extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    stylesheetSrc: PropTypes.string,
    title: PropTypes.string.isRequired,
    template: PropTypes.string,
    className: PropTypes.string,
    currentLanguage: PropTypes.string,
    type: PropTypes.string.isRequired,
  };

  static contextType = SectionViewportContext;

  state = {
    isFrameContentReady: false,
  };

  init = async () => {
    const script = document.createElement('script');
    script.src = iframeResizerContentWindow;

    if (!this.iframeDocument) {
      return;
    }

    this.iframeDocument.head.appendChild(script);
    this.iframeDocument.documentElement.setAttribute('lang', `${this.props.currentLanguage}`);

    const gtmScript = document.createElement('script');
    gtmScript.src = gtmEelevatorScript;

    this.iframeDocument.head.appendChild(gtmScript);

    syncIframeSize(
      {
        checkOrigin: false,
        heightCalculationMethod: 'documentElementOffset',
        resizeFrom: 'child',
      },
      this.formRoot.current,
    );

    this.setState({ isFrameContentReady: true });

    const css = await fetchCss(this.props.stylesheetSrc);
    const styleTag = document.createElement('style');
    styleTag.type = 'text/css';
    if (styleTag.styleSheet) {
      styleTag.styleSheet.cssText = css;
    } else {
      styleTag.append(document.createTextNode(css));
    }
    this.iframeDocument.head.appendChild(styleTag);
  };

  formRoot = React.createRef();

  get iframeDocument() {
    return path(['current', 'contentDocument'], this.formRoot);
  }

  get iframeWindow() {
    return path(['current', 'contentWindow'], this.formRoot);
  }

  get iframeLocationSearch() {
    const params = { ...passthroughParams, ...parse(location.search) };

    const paramString = Object.keys(params)
      .reduce((accum, key) => accum + `${key}=${params[key]}&`, '?')
      .replace(/\&$/, '');
    return paramString;
  }

  render() {
    const { title, children, className, template, type } = this.props;
    const src = template || `/${iframeHtml(type)}.html${this.iframeLocationSearch}`;

    return (
      this.context.isActive && (
        <Fragment>
          <IFrame
            aria-label={title}
            ref={this.formRoot}
            src={src}
            onLoad={this.init}
            title={`${title} - ${uniqueId()}`}
            className={className}
          />
          {this.state.isFrameContentReady &&
            children &&
            ReactDOM.createPortal(
              children({
                host: this.iframeDocument,
                hostWindow: this.iframeWindow,
              }),
              this.iframeDocument.body,
            )}
        </Fragment>
      )
    );
  }
}
